import { styleVariants } from '@vanilla-extract/css';

export const sizes = styleVariants({
  xs: { height: '1rem' }, // 16px
  sm: { height: '1.25rem' }, // 20px
  md: { height: '1.5rem' }, // 24px
  lg: { height: '1.875rem' }, // 30px
  xl: { height: '2.5rem' }, // 40px
});
